import { createReducer } from 'redux-act';

import {
  MERCHANTS_FETCH_DATA_INIT,
  MERCHANTS_FETCH_DATA_SUCCESS,
  MERCHANTS_FETCH_DATA_FAIL,
  MERCHANTS_DELETE_MERCHANT_INIT,
  MERCHANTS_DELETE_MERCHANT_SUCCESS,
  MERCHANTS_DELETE_MERCHANT_FAIL,
  MERCHANTS_CREATE_MERCHANT_INIT,
  MERCHANTS_CREATE_MERCHANT_SUCCESS,
  MERCHANTS_CREATE_MERCHANT_FAIL,
  MERCHANTS_MODIFY_MERCHANT_INIT,
  MERCHANTS_MODIFY_MERCHANT_SUCCESS,
  MERCHANTS_MODIFY_MERCHANT_FAIL,
  MERCHANTS_CLEAN_UP,
  MERCHANTS_CLEAR_DATA_LOGOUT,
} from 'state/actionCreators/merchants';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
};

export const merchantsReducer = createReducer(
  {
    [MERCHANTS_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [MERCHANTS_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.data,
      loading: false,
      error: null,
    }),
    [MERCHANTS_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [MERCHANTS_DELETE_MERCHANT_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [MERCHANTS_DELETE_MERCHANT_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.filter((elem) => elem.id !== payload.id),
      loading: false,
      error: null,
      deleted: true,
    }),
    [MERCHANTS_DELETE_MERCHANT_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [MERCHANTS_CREATE_MERCHANT_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [MERCHANTS_CREATE_MERCHANT_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.concat(payload.merchant),
      loading: false,
      error: null,
      success: true,
    }),
    [MERCHANTS_CREATE_MERCHANT_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [MERCHANTS_MODIFY_MERCHANT_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [MERCHANTS_MODIFY_MERCHANT_SUCCESS]: (state, payload) => ({
      ...state,
      data: !state.data
        ? []
        : state.data.map((elem) => {
            if (elem.id === payload.id) {
              return {
                name: payload.merchant.name,
                location: payload.merchant.location,
                id: payload.id,
                logoUrl: payload.merchant.logoUrl,
                createdAt: payload.merchant.createdAt,
                email: elem.email,
              };
            }
            return elem;
          }),
      loading: false,
      error: null,
      success: true,
    }),
    [MERCHANTS_MODIFY_MERCHANT_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [MERCHANTS_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
    }),
    [MERCHANTS_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
  },
  initialState
);
